import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import api from '../lib/api';
// `Activity` se va OTRA VEZ en la TANDA 12 (firma #182): la tarjeta de
// Diagnóstico se mudó al drawer y aquí vuelve a no tener consumidor.
import { Eye, EyeOff, Lock, User, Mail, CheckCircle2, Package, AlertTriangle, Crown, Sparkles, Trash2, Languages, CalendarClock, RotateCw, CreditCard, GraduationCap } from 'lucide-react';
import { toast } from 'sonner';
import { IS_APP_BUILD } from '../lib/buildTarget';
import LanguageSelector from '../components/LanguageSelector';
import DeleteAccountModal from '../components/DeleteAccountModal';
// PILOTO-1 (firma #79): la entrada discreta de «unirme a un grupo».
import JoinGroupCard from '../components/JoinGroupCard';
// LAPIDA post-t7-2c (E1): murio la tarjeta "Invita a un amigo" (`InvitaAmigo`) de Ajustes.
import { formatDateLong } from '../lib/dateFormat';
import { useScreenData } from '../hooks/useScreenData';
import { SettingsSectionSkeleton } from '../components/skeletons';
import { useNetworkStatus } from '../hooks/useNetworkStatus';
import { log as diagLog } from '../lib/diag/readyChainLog';
// TANDA AS-3 — la sección Suscripción se bifurca por proveedor de cobro. La rama de
// Stripe queda EXACTAMENTE como hoy; la de Apple sólo existe en build de app, que es
// donde vive el plugin que abre la pantalla nativa de suscripciones.
import * as purchases from '../lib/purchases';
import { appleErrorCopy } from '../lib/appleErrorCopy';
import { fuenteDePro } from '../lib/fuenteDePro';
// #433/#434 - la ventana del motivo, la MISMA para las puertas de cancelar Pro
// (web: "Cancelar suscripción"; app: la hoja de Apple).
import CancelarConMotivo from '../components/CancelarConMotivo';
// pantallas-alumno (G): las piezas comunes del alumno (parte 2, seccion 4 "Ajustes").
import {
  Boton, APRETADO, clasesDeBoton, EncabezadoDePagina, BotonDeRegreso, TarjetaDeAjustes, LineaDivisoria, CajaDeTexto,
  RecuadroDeEstado, Ventana, BOTON_VENTANA_PRINCIPAL, BOTON_VENTANA_SECUNDARIO,
  IconoDeVentana, ListaConVinetas,
} from '../components/alumno';
import { ESTADO_DEL_REBOTE } from '../lib/razonDelRegistro';
// estilos-1 (Bloque C, 4.3): "Estilo de examen" (solo con la perilla encendida) y la misma hoja del Panel.
import { useEstilos, cargarEstilosSiFalta, guardarPreferido, nombreLargo, QUIZESSA } from '../lib/estilos';
import EstiloDeExamen from '../components/panel/EstiloDeExamen';

/* ── TANDA 12 (firma #182) — AQUÍ VIVÍA LA DIRECCIÓN DE ADMINISTRADOR ────────
 * La TANDA 11 la había traído a este archivo para gatear la tarjeta de
 * Diagnóstico. Esa tarjeta se mudó al drawer, así que aquí ya no queda nada que
 * gatear y la constante se va con ella: esta pantalla vuelve a no saber quién es
 * administrador. DÓNDE VIVE AHORA, y es una sola: `components/routeGuards.js` la
 * exporta, y de ahí la leen las dos páginas de la consola.
 *
 * ── AS-6f y TANDA 12 - LA SECCIÓN "Diagnóstico" ─────────────────────────────
 * Ya no vive aquí: la puerta al visor de la cadena de entrega se mudó al cajón
 * del menú (solo administradores y app). Ajustes es sólo Ajustes. Guardas:
 * `lib/as6f.visorFuera.test.js`, `components/Sidebar.visorCosG.test.js` y
 * `pages/SettingsPage.puertaVisor*.test.js`.
 *
 * ── pantallas-alumno (G) - AJUSTES CON EL LENGUAJE DEL PANEL ────────────────
 * Parte 2, seccion 4, y sus firmas del 19-oct:
 *   . hasta 720, centrada; encabezado de la casa con el boton de regreso; las
 *     tarjetas de Ajustes en el orden de hoy (sin "Diagnostics" para el alumno);
 *   . FIRMA 1: se quita "Switch to Free" (hacia lo mismo que "Cancel Subscription")
 *     y, como "Change plan" se queda sin opciones, tampoco sale su titulo. La
 *     ventana AJ6 y la ventana "Downgrade to {plan}?" (sin camino desde que no
 *     existe Premium) se fueron con el. El servidor no cambia;
 *   . AJ8-b: en la web, un Pro cobrado por Apple ve `apple_managed_web`, sin
 *     botones; sin fuente conocida, lo de hoy;
 *   . P8: si falla la carga de Subscription o de Credit Pack History, ESA tarjeta
 *     pinta el recuadro I2 con `section_load_failed` y "Retry", que vuelve a pedir
 *     SOLO lo suyo (Join a group lo hace dentro de `JoinGroupCard`);
 *   . P9: con la cancelacion programada no sale "Next billing date";
 *   . P10: los precios con dos decimales, formateados aqui ("$89.90/year");
 *   . las ventanas de cancelar y de borrar la cuenta con el estilo de ventana del
 *     alumno, su contenido de hoy y las vinetas dibujadas. */

const PLAN_LABELS = { free: 'Free', pro: 'Pro' };
const PLAN_CREDITS = { free: 5, pro: 50 };

/* pantallas-alumno (G), P10: el precio con dos decimales SIEMPRE, formateado en el cliente.
   El servidor manda un numero (`89.9`, porque Python no escribe el cero de mas); si llegara algo
   que no es numero, se pinta tal cual (lo de hoy). */
export function precioConDosDecimales(precio) {
  if (precio === null || precio === undefined || String(precio).trim() === '') return precio;
  const n = Number(precio);
  return Number.isFinite(n) ? n.toFixed(2) : precio;
}

// Fetcher combinado de las dos secciones — cacheado bajo 'settings' (regla de
// frescura F4.3b).
// pantallas-alumno (G), P8: una lectura que se cae ya no se disfraza de "vino vacio".
// Cada mitad dice si fallo (`subFallo`, `packFallo`) con lo que ya regresa la llamada
// (el rechazo); `subInfo` y `packHistory` quedan como siempre (null y []).
async function fetchSettingsData() {
  const [subRes, packRes] = await Promise.all([
    api.get('/payments/subscription-info').then((r) => ({ data: r.data, fallo: false }), () => ({ data: null, fallo: true })),
    api.get('/user/pack-history').then((r) => ({ data: r.data, fallo: false }), () => ({ data: { purchases: [] }, fallo: true })),
  ]);
  // F6.7b post-smoke - SCR.PAINT: solo cuando el servidor DE VERDAD contestó.
  // No-op en web.
  if (subRes.data) diagLog('SCR.PAINT', { screen: 'settings' });
  return {
    subInfo: subRes.data,
    packHistory: packRes.data?.purchases || [],
    subFallo: subRes.fallo,
    packFallo: packRes.fallo,
  };
}

/* remates-1-2-1 (B3) - los 400 con los que el servidor dice "el motivo no está
   completo». Un rechazo de validación, no una falla: ver `confirmarMotivo`.
   remates-2 (C2): son TRES. El texto corto con "Otro" / "Me falta una funcion" dejo
   de ser `reason_required` y es `reason_text_required`; si esta lista no lo
   reconociera, ese 400 abriria la hoja de Apple (ley de #434). */
export const CODIGOS_DEL_MOTIVO = ['reason_required', 'reason_text_required', 'reason_text_too_long'];

export function esRechazoDelMotivo(err) {
  return err?.response?.status === 400
    && CODIGOS_DEL_MOTIVO.indexOf(err.response.data?.error_code) !== -1;
}

const TEXTO_SECUNDARIO = 'text-[13px] leading-5 text-[#9A9A9A]';
// Medicion (regla 10): todo elemento que se le pasa a `components` de un Trans lleva su `key` (sin ella, React avisa en
// la consola de desarrollo; lo que se pinta no cambia).
const NEGRITA = <strong key="negrita" className="text-[#F4F4F3] font-semibold" />;

function PlanActualEnLinea({ plan, t }) {
  return (
    <p className="text-[14px] text-[#9A9A9A]">
      <Trans t={t} i18nKey="settings:subscription.current_plan_inline"
        values={{ plan: PLAN_LABELS[plan] || plan }}
        components={{ 1: <span key="1" className="text-[#F4F4F3] font-semibold" /> }} />
    </p>
  );
}

export default function SettingsPage() {
  const { user, logout, refreshUser } = useAuth();
  const navigate = useNavigate();
  // `pricing` (las claves `iap.*` de Restaurar compras) SÓLO en build de app: en web
  // declararlo aquí traería una petición de locale que hoy esta pantalla no hace.
  const { t, i18n } = useTranslation(IS_APP_BUILD ? ['settings', 'pricing'] : 'settings');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPasswords, setShowPasswords] = useState(false);
  const [loading, setLoading] = useState(false);
  // F6.7b (2ª pasada) - EL ATAJO OFFLINE DE SETTINGS: con DICTAMEN de que no hay
  // señal, las dos lecturas no salen y la pantalla pinta lo que sí sabe (el plan del
  // user) más un aviso honesto de que la sección se actualizará al volver la red.
  const net = useNetworkStatus();
  // enabled:false para guests — conserva el "skip API calls for guests" (la
  // página además los redirige a /signup abajo).
  const { data: settingsData, loading: sectionsLoading, setData: setSettingsData, refetch: refetchSettings } =
    useScreenData('settings', fetchSettingsData, { enabled: !user?.is_guest && !net.isOffline });
  const subInfo = settingsData?.subInfo || null;
  const packHistory = settingsData?.packHistory || [];
  const subFallo = Boolean(settingsData?.subFallo);
  const packFallo = Boolean(settingsData?.packFallo);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  /* #433/#434 — LA VENTANA DEL MOTIVO, y a qué puerta pertenece.
     `null` = cerrada. Si no, `{ tipo }`:
       'cancel'    -> POST /payments/cancel-subscription (web)
       'apple'     -> POST /account/cancel-reason y luego la hoja del sistema
     pantallas-alumno (G), firma 1: murio la puerta 'downgrade' (era "Switch to Free"). */
  const [motivoPara, setMotivoPara] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);
  // P8: la tarjeta cuyo "Retry" esta pidiendo ('sub' | 'packs' | '')
  const [reintentando, setReintentando] = useState('');
  // estilos-1 (4.3): la lectura de la sesion (la misma del Panel) y la hoja de "Cambiar".
  const estilos = useEstilos();
  const [estiloAbierto, setEstiloAbierto] = useState(false);
  const botonDelEstilo = useRef(null);
  const idDeEstilos = user && !user.is_guest ? user.id : null;
  useEffect(() => {
    if (!idDeEstilos) return;
    cargarEstilosSiFalta({ id: idDeEstilos });
  }, [idDeEstilos]);

  // Write-through de las mutaciones de suscripción (cancel/undo): el subInfo fresco
  // que devuelve el re-fetch puntual entra al cache también.
  const setSubInfo = (next) => setSettingsData(prev => ({ packHistory: [], ...(prev || {}), subInfo: next, subFallo: false }));

  // La señal VOLVIÓ (dictamen del vigía) → esta pantalla vuelve a pedir fresco sola.
  useEffect(() => {
    if (!net.isOnline || user?.is_guest) return;
    refetchSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [net.isOnline]);

  // COS-19 - Ajustes SIEMPRE se abre desde el tope (el `<main>` del chasis conserva
  // su scroll entre rutas; ver la historia en git).
  useEffect(() => {
    const scrollport = document.querySelector('[data-testid="content-area"]');
    if (scrollport) scrollport.scrollTop = 0;
  }, []);

  // Disable header clicks while any modal is open
  useEffect(() => {
    const header = document.querySelector('[data-testid="app-header"]');
    if (!header) return;
    header.style.pointerEvents = (showCancelModal || motivoPara) ? 'none' : '';
    return () => { header.style.pointerEvents = ''; };
  }, [showCancelModal, motivoPara]);

  // Block guest access entirely — redirect to signup
  // pantallas-alumno (G), P12: con la razon en el estado de la navegacion (`lib/razonDelRegistro.js`).
  if (user?.is_guest) {
    return <Navigate to="/signup" replace state={ESTADO_DEL_REBOTE} />;
  }

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) { toast.error(t('toasts.passwords_no_match')); return; }
    if (newPassword.length < 8) { toast.error(t('toasts.password_min')); return; }
    setLoading(true);
    try {
      await api.put('/auth/change-password', { current_password: currentPassword, new_password: newPassword });
      toast.success(t('toasts.password_changed'));
      setCurrentPassword(''); setNewPassword(''); setConfirmPassword('');
    } catch (err) { toast.error(err.response?.data?.detail || t('toasts.failed')); }
    finally { setLoading(false); }
  };

  const handleCancel = async (reason) => {
    setActionLoading(true);
    try {
      await api.post('/payments/cancel-subscription', { ...(reason || {}) });
      toast.success(t('toasts.cancel_scheduled'));
      setShowCancelModal(false);
      const res = await api.get('/payments/subscription-info');
      setSubInfo(res.data);
    } catch (err) { toast.error(err.response?.data?.detail || t('toasts.failed_cancel')); }
    finally { setActionLoading(false); }
  };

  /* #433/#434 — EL ÚNICO SITIO DONDE EL MOTIVO SE CONVIERTE EN ACCIÓN.
     La ventana llama aquí con el código y el texto; según la puerta que la
     abrió, esto cancela en Stripe (con el motivo en la MISMA petición) o
     apunta el motivo y abre la hoja de Apple.

     LEY DE LA RAMA DE APPLE: si la petición del motivo se cae, Apple se abre
     IGUAL. Nuestra encuesta no puede ser una tranca entre el usuario y su
     pantalla de suscripciones — Apple rechaza apps por eso.

     remates-1-2-1 (B3) - UN 400 DE VALIDACIÓN NO ES UNA FALLA: la ventana se queda
     abierta, se pinta el aviso del servidor y Apple NO se abre. */
  const confirmarMotivo = async (reason_code, reason_text) => {
    const destino = motivoPara;
    if (!destino) return;
    const reason = { reason_code, reason_text };
    if (destino.tipo === 'apple') {
      setActionLoading(true);
      try {
        await api.post('/account/cancel-reason', { ...reason, source: 'apple' });
      } catch (err) {
        if (esRechazoDelMotivo(err)) {
          setActionLoading(false);
          toast.error(err.response?.data?.detail || t('toasts.failed'));
          return;
        }
        /* cualquier otra cosa nunca bloquea el camino a Apple */
      }
      setActionLoading(false);
      setMotivoPara(null);
      await abrirGestionApple();
      return;
    }
    await handleCancel(reason);
    setMotivoPara(null);
  };

  const handleUndoDowngrade = async () => {
    setActionLoading(true);
    try {
      const res = await api.post('/payments/undo-downgrade');
      toast.success(res.data.message || t('toasts.downgrade_cancelled'));
      const info = await api.get('/payments/subscription-info');
      setSubInfo(info.data);
    } catch (err) { toast.error(err.response?.data?.detail || t('toasts.failed_undo')); }
    finally { setActionLoading(false); }
  };

  /* pantallas-alumno (G), P8: "Retry" de UNA tarjeta pide solo lo suyo. Si vuelve a
     fallar, la tarjeta se queda en su recuadro. */
  const reintentarSuscripcion = async () => {
    setReintentando('sub');
    try {
      const res = await api.get('/payments/subscription-info');
      setSubInfo(res.data);
    } catch (err) { /* sigue el recuadro */ }
    finally { setReintentando(''); }
  };
  const reintentarPaquetes = async () => {
    setReintentando('packs');
    try {
      const res = await api.get('/user/pack-history');
      setSettingsData(prev => ({ subInfo: null, ...(prev || {}), packHistory: res.data?.purchases || [], packFallo: false }));
    } catch (err) { /* sigue el recuadro */ }
    finally { setReintentando(''); }
  };

  const plan = user?.plan || 'free';

  /* ── AS-3 — LA BIFURCACIÓN POR PROVEEDOR ────────────────────────────────────
     La rama de Apple se pinta SÓLO en build de app: es donde vive el plugin que
     abre la pantalla de Suscripciones del sistema. Ni precio ni fecha de
     renovación (ningún endpoint los trae para Apple).
     remates-1-2-1 (A, firma #458) - la fuente se lee de `lib/fuenteDePro.js`
     (`billing_source`, con caída a `billing_provider`).
     pantallas-alumno (G), AJ8-b - EN LA WEB, la misma fuente en Apple ya no cae a
     "not linked": dice que se maneja desde el iPhone, sin botones. */
  const fuente = fuenteDePro(user);
  const applePlan = IS_APP_BUILD && fuente === 'apple';
  const appleEnLaWeb = !IS_APP_BUILD && fuente === 'apple';

  const abrirGestionApple = async () => {
    const res = await purchases.openManageSubscriptions();
    if (res.status !== 'ok') toast.error(t('toasts.failed'));
  };

  const restaurarCompras = async () => {
    setActionLoading(true);
    const res = await purchases.restore();
    if (res.status === 'ok' && res.applied > 0) {
      await refreshUser();
      toast.success(t('pricing:iap.restore_success'));
    } else if (res.status === 'ok') {
      toast.info(t('pricing:iap.restore_empty'));
    } else {
      toast.error(appleErrorCopy(res.error, t));
    }
    setActionLoading(false);
  };

  const recuadroDeFalla = (testid, alReintentar, clave) => (
    <RecuadroDeEstado tipo="no_cargo" testid={testid} texto={t('section_load_failed')}
      accion={{ texto: t('common:offline.no_connection.cta'), onClick: alReintentar, icono: RotateCw, trabajando: reintentando === clave }} />
  );


  const fechaDeCobro = formatDateLong(subInfo?.billing_date);
  const intro = subInfo?.billing_date
    ? <Trans t={t} i18nKey="settings:modals.intro_with_date" values={{ plan: PLAN_LABELS[plan], date: fechaDeCobro }} components={{ 1: NEGRITA, 3: NEGRITA }} />
    : <Trans t={t} i18nKey="settings:modals.intro_no_date" values={{ plan: PLAN_LABELS[plan] }} components={{ 1: NEGRITA }} />;

  const suscripcion = () => {
    if (applePlan) {
      /* AS-3 - cobrada por Apple (app): se dice la verdad y se ofrecen los dos
         caminos que sí existen. #434: el primero abre la ventana del motivo y de
         ahí "Continuar a Apple" abre la hoja: un toque de distancia, siempre. */
      return (
        <div className="flex flex-col gap-4" data-testid="subscription-apple">
          <PlanActualEnLinea plan={plan} t={t} />
          <p className={TEXTO_SECUNDARIO} data-testid="apple-managed-blurb">{t('subscription.apple_managed')}</p>
          <div className="flex flex-wrap gap-2">
            <Boton icono={Crown} onClick={() => setMotivoPara({ tipo: 'apple' })} testid="apple-manage-btn">
              {t('subscription.apple_manage_btn')}
            </Boton>
            <Boton variante="secundario" onClick={restaurarCompras} trabajando={actionLoading} testid="apple-restore-btn">
              {t('pricing:iap.restore_btn')}
            </Boton>
          </div>
        </div>
      );
    }
    if (sectionsLoading) return <SettingsSectionSkeleton testid="skeleton-settings-subscription" />;
    if (net.isOffline && !subInfo) {
      /* Sin señal y sin dato de servidor: se dice lo que se sabe (el plan del user). */
      return (
        <div className="flex flex-col gap-2" data-testid="subscription-offline">
          <PlanActualEnLinea plan={plan} t={t} />
          <p className={TEXTO_SECUNDARIO}>{t('common:offline.section_needs_connection')}</p>
        </div>
      );
    }
    if (subFallo && !subInfo) return recuadroDeFalla('subscription-load-failed', reintentarSuscripcion, 'sub');
    if (plan === 'free' && !subInfo?.has_subscription) {
      return (
        <div className="flex flex-col gap-3">
          <p className="text-[14px] text-[#9A9A9A]"><Trans t={t} i18nKey="settings:subscription.free_blurb" components={{ 1: <span key="1" className="text-[#F4F4F3] font-semibold" /> }} /></p>
          <p className={TEXTO_SECUNDARIO}>{t('subscription.free_upgrade_hint')}</p>
          <div>
            <Boton icono={Sparkles} onClick={() => navigate('/upgrade')} testid="upgrade-link">{t('subscription.upgrade_btn')}</Boton>
          </div>
        </div>
      );
    }
    if (subInfo?.has_subscription && subInfo.pago_fallido) {
      /* post-t7-2-dinero (A5): el ultimo cobro no paso y la cuenta ya es Free. El plan de verdad,
         el aviso en el recuadro naranja suave del Panel y "Update card" a la factura de Stripe (en la
         app, la liga absoluta con destino nuevo sale al navegador del sistema). Sin fecha de cobro,
         sin precio y sin tarjeta; "Cancel Subscription" se queda para parar los reintentos. */
      const url = subInfo.pago_fallido.url;
      return (
        <div className="flex flex-col gap-3" data-testid="subscription-pago-fallido">
          <div className="flex flex-wrap items-center gap-x-2.5 gap-y-1.5 text-[14px]">
            <span className="text-[#9A9A9A]">{t('subscription.current_plan_label')}</span>
            <span className="text-[#F4F4F3] font-semibold">{PLAN_LABELS[plan] || plan}</span>
          </div>
          <div className="flex flex-col gap-3 rounded-[14px] border border-[#3A2414] bg-[#1A120C] p-3.5" data-testid="pago-fallido-banner">
            <p className="flex items-start gap-2.5 text-[14px] leading-5 text-[#F4F4F3]">
              <CreditCard className="w-4 h-4 mt-0.5 shrink-0 text-[#F7A06A]" aria-hidden="true" />
              <span>{t('subscription.pago_fallido')}</span>
            </p>
            {url ? (
              <div>
                <a href={url} target="_blank" rel="noopener noreferrer" className={clasesDeBoton()} data-testid="pago-fallido-btn">
                  {t('subscription.pago_fallido_btn')}
                </a>
              </div>
            ) : null}
          </div>
          <LineaDivisoria />
          <div>
            <button type="button" onClick={() => setShowCancelModal(true)}
              className={`relative inline-flex items-center h-11 md:h-10 px-1 -mx-1 rounded-lg text-[14px] font-semibold text-[#F87171] focus:outline-none focus-visible:ring-2 focus-visible:ring-white ${APRETADO}`}
              data-testid="cancel-subscription-btn">
              {t('subscription.cancel_subscription_btn')}
            </button>
          </div>
        </div>
      );
    }
    if (subInfo?.has_subscription) {
      const programada = Boolean(subInfo.cancel_at_period_end);
      return (
        <div className="flex flex-col gap-3">
          <div className="flex flex-wrap items-center gap-x-2.5 gap-y-1.5 text-[14px]">
            <span className="text-[#9A9A9A]">{t('subscription.current_plan_label')}</span>
            <span className="text-[#F4F4F3] font-semibold">{PLAN_LABELS[plan]}</span>
            {subInfo.plan_price !== null && subInfo.plan_price !== undefined && subInfo.plan_price !== '' && (
              <span className="text-[13px] text-[#9A9A9A]">
                {t(subInfo.billing_interval === 'year' ? 'subscription.price_per_year' : 'subscription.price_per_month',
                  { price: precioConDosDecimales(subInfo.plan_price) })}
              </span>
            )}
            {programada && (
              <span className="inline-flex items-center gap-1.5 h-6 px-2.5 rounded-full border border-[#3A2414] bg-[#1A120C] text-[12.5px] font-semibold text-[#F7A06A]"
                data-testid="subscription-cancels-chip">
                <CalendarClock className="w-3.5 h-3.5" aria-hidden="true" />
                {t('subscription.cancels_on', { date: fechaDeCobro || t('subscription.period_end_fallback') })}
              </span>
            )}
          </div>
          {/* pantallas-alumno (G), P9: con la cancelacion programada la fecha ya no es de cobro. */}
          {subInfo.billing_date && !programada && (
            <p className={TEXTO_SECUNDARIO}>{t('subscription.next_billing', { date: fechaDeCobro })}</p>
          )}
          {subInfo.card_last4 && (
            <p className={TEXTO_SECUNDARIO} data-testid="card-info">
              {t('subscription.card_ending', { brand: subInfo.card_brand ? subInfo.card_brand.charAt(0).toUpperCase() + subInfo.card_brand.slice(1) : t('subscription.card_generic'), last4: subInfo.card_last4 })}
            </p>
          )}

          {/* El aviso de cancelacion: el recuadro naranja suave del Panel, con "Keep Pro" debajo. */}
          {programada && (
            <div className="flex flex-col gap-3 rounded-[14px] border border-[#3A2414] bg-[#1A120C] p-3.5" data-testid="scheduled-change-banner">
              <p className="text-[14px] leading-5 text-[#F4F4F3]">
                {subInfo.pending_resubscribe
                  ? <Trans t={t} i18nKey="settings:subscription.scheduled_switch" values={{ plan: PLAN_LABELS[subInfo.pending_resubscribe], date: fechaDeCobro || t('subscription.billing_period_end_fallback') }} components={{ 1: <strong key="1" className="font-semibold text-[#F7A06A]" />, 3: <strong key="3" className="font-semibold text-[#F7A06A]" /> }} />
                  : <Trans t={t} i18nKey="settings:subscription.scheduled_cancel" values={{ date: fechaDeCobro || t('subscription.billing_period_end_fallback') }} components={{ 1: <strong key="1" className="font-semibold text-[#F7A06A]" /> }} />
                }
              </p>
              <div>
                <Boton onClick={handleUndoDowngrade} trabajando={actionLoading} testid="undo-downgrade-btn">
                  {t('subscription.keep_plan', { plan: PLAN_LABELS[plan] })}
                </Boton>
              </div>
            </div>
          )}

          {/* pantallas-alumno (G), firma 1 de la parte 2: aqui vivia "Change plan" con "Switch to Free"
              (el boton de bajar a Free). Hacia exactamente lo mismo que "Cancel Subscription" y se quito; sin
              opciones, el titulo tampoco sale. */}

          {/* Cancel: texto rojo, sin caja */}
          {!programada && (
            <>
              <LineaDivisoria />
              <div>
                <button type="button" onClick={() => setShowCancelModal(true)}
                  className={`relative inline-flex items-center h-11 md:h-10 px-1 -mx-1 rounded-lg text-[14px] font-semibold text-[#F87171] focus:outline-none focus-visible:ring-2 focus-visible:ring-white ${APRETADO}`}
                  data-testid="cancel-subscription-btn">
                  {t('subscription.cancel_subscription_btn')}
                </button>
              </div>
            </>
          )}
        </div>
      );
    }
    /* Plan sin suscripción de Stripe: asignado por soporte, de Apple visto en la web (AJ8-b) o no ligado. */
    return (
      <div className="flex flex-col gap-2" data-testid="admin-assigned-plan">
        <PlanActualEnLinea plan={plan} t={t} />
        {appleEnLaWeb ? (
          <p className={TEXTO_SECUNDARIO} data-testid="subscription-apple-web">{t('subscription.apple_managed_web')}</p>
        ) : subInfo?.admin_assigned ? (
          <p className={TEXTO_SECUNDARIO}>{t('subscription.admin_assigned')}</p>
        ) : (
          <p className={TEXTO_SECUNDARIO}>{t('subscription.not_linked')}</p>
        )}
      </div>
    );
  };

  const paquetes = () => {
    if (sectionsLoading) return <SettingsSectionSkeleton testid="skeleton-settings-packs" />;
    /* Sin señal: "no compraste paquetes" sería mentira - no se leyó nada. */
    if (net.isOffline && !settingsData) {
      return <p className={TEXTO_SECUNDARIO} data-testid="packs-offline">{t('common:offline.section_needs_connection')}</p>;
    }
    if (packFallo) return recuadroDeFalla('packs-load-failed', reintentarPaquetes, 'packs');
    if (packHistory.length === 0) return <p className="text-[14px] text-[#9A9A9A]">{t('packs.empty')}</p>;
    return (
      <div className="flex flex-col">
        {packHistory.map((p, i) => (
          <div key={i} className="flex items-center justify-between gap-3 min-h-[40px] border-b border-[#1F1F1F] last:border-0">
            <span className="text-[14px] text-[#C8C8C8]">{t('packs.row', { credits: p.credits, amount: Number(p.amount_usd || 0).toFixed(2) })}</span>
            <span className="text-[13px] text-[#7E7E7E] tabular-nums">{p.timestamp ? new Date(p.timestamp).toLocaleDateString() : '-'}</span>
          </div>
        ))}
      </div>
    );
  };

  const ojo = (
    <button type="button" onClick={() => setShowPasswords(!showPasswords)}
      className="w-11 h-11 md:w-10 md:h-10 rounded-lg flex items-center justify-center text-[#9A9A9A] hoverable:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white">
      {showPasswords ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
    </button>
  );

  return (
    <div className="max-w-[720px] mx-auto flex flex-col gap-4 animate-fade-in-up" data-testid="settings-page">
      <EncabezadoDePagina
        className="mb-2"
        titulo={t('title')}
        regreso={<BotonDeRegreso etiqueta={t('common:back')} onClick={() => navigate(-1)} testid="settings-back-btn" />}
      />

      {/* Language / Idioma */}
      <TarjetaDeAjustes icono={Languages} titulo={t('language.heading')} testid="language-section">
        <LanguageSelector variant="settings" />
      </TarjetaDeAjustes>

      {/* estilos-1 (4.3): "Exam style", debajo del idioma (las preferencias de la cuenta); solo con la perilla. */}
      {estilos.on ? (
        <TarjetaDeAjustes icono={GraduationCap} titulo={t('settings:estilo.titulo')} testid="estilo-section">
          <p className={TEXTO_SECUNDARIO}>{t('settings:estilo.renglon')}</p>
          <div className="flex items-center justify-between gap-3 min-w-0">
            <div className="min-w-0">
              <p className="text-[13px] leading-5 text-[#9A9A9A]">{t('settings:estilo.etiqueta')}</p>
              <p className={`text-[15px] leading-[22px] font-semibold truncate ${estilos.preferido ? 'text-[#FF6B00]' : 'text-[#F4F4F3]'}`}
                data-testid="estilo-valor">
                {nombreLargo(estilos, estilos.preferido || QUIZESSA, i18n?.language) || t('dashboard:estilo.quizessa')}
              </p>
            </div>
            <Boton variante="secundario" ref={botonDelEstilo} onClick={() => setEstiloAbierto(true)} testid="estilo-cambiar">
              {t('settings:estilo.cambiar')}
            </Boton>
          </div>
        </TarjetaDeAjustes>
      ) : null}
      {estilos.on && estiloAbierto ? (
        <EstiloDeExamen t={t} idioma={i18n?.language} catalogo={estilos} inicial={estilos.preferido} volverA={botonDelEstilo}
          alCerrar={() => setEstiloAbierto(false)}
          alListo={(clave) => { guardarPreferido(clave); setEstiloAbierto(false); }} />
      ) : null}

      {/* Subscription Section */}
      <TarjetaDeAjustes icono={Crown} titulo={t('subscription.heading')} testid="subscription-section">
        {suscripcion()}
      </TarjetaDeAjustes>

      {/* Change Password */}
      <TarjetaDeAjustes icono={Lock} titulo={t('password.heading')} testid="password-section">
        <form onSubmit={handleChangePassword} className="flex flex-col gap-4">
          <CajaDeTexto id="settings-current-password" etiqueta={t('password.current')}
            type={showPasswords ? 'text' : 'password'} name="current_password" autoComplete="current-password"
            valor={currentPassword} onCambio={setCurrentPassword} adornoDerecha={ojo} data-testid="current-password-input" />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <CajaDeTexto id="settings-new-password" etiqueta={t('password.new')}
              type={showPasswords ? 'text' : 'password'} name="new_password" autoComplete="new-password"
              valor={newPassword} onCambio={setNewPassword} data-testid="new-password-input" />
            <CajaDeTexto id="settings-confirm-password" etiqueta={t('password.confirm')}
              type={showPasswords ? 'text' : 'password'} name="new_password_confirm" autoComplete="new-password"
              valor={confirmPassword} onCambio={setConfirmPassword} data-testid="confirm-password-input" />
          </div>
          <div>
            <Boton type="submit" disabled={!currentPassword || !newPassword} trabajando={loading} testid="change-password-btn">
              {t('password.update_btn')}
            </Boton>
          </div>
        </form>
      </TarjetaDeAjustes>

      {/* Account Info */}
      <TarjetaDeAjustes icono={User} titulo={t('account.heading')} testid="account-section">
        <div className="flex items-center gap-2 text-[14px] min-w-0">
          <Mail className="w-4 h-4 shrink-0 text-[#9A9A9A]" />
          <span className="text-[#C8C8C8] truncate" data-testid="account-email">{user?.email || t('account.no_email')}</span>
          {user?.verified && <CheckCircle2 className="w-4 h-4 shrink-0 text-[#4ADE80]" />}
        </div>
        <LineaDivisoria />
        <div>
          <button type="button" onClick={() => setShowDeleteModal(true)}
            className={`relative inline-flex items-center justify-center gap-1.5 h-11 md:h-10 px-4 rounded-xl bg-[#1B1B1B] border border-[#5A2323] text-[14px] font-semibold text-[#F87171] focus:outline-none focus-visible:ring-2 focus-visible:ring-white ${APRETADO}`}
            data-testid="delete-account-btn">
            <Trash2 className="w-4 h-4" aria-hidden="true" /> {t('delete_account.button')}
          </button>
        </div>
      </TarjetaDeAjustes>

      <DeleteAccountModal open={showDeleteModal} onClose={() => setShowDeleteModal(false)} />

      {/* #433/#434 - LA VENTANA DEL MOTIVO. Una sola instancia para las puertas;
          la variante decide el botón primario y la regla del texto. */}
      <CancelarConMotivo
        open={!!motivoPara}
        variante={motivoPara?.tipo === 'apple' ? 'app' : 'web'}
        loading={actionLoading}
        onClose={() => setMotivoPara(null)}
        onConfirm={confirmarMotivo}
      />

      {/* PILOTO-1 (firma #79) — LA ENTRADA DISCRETA, visible para TODA cuenta
          registrada. Va DESPUÉS de la cuenta y ANTES del historial de paquetes. */}
      <JoinGroupCard />

      {/* Credit Pack History */}
      <TarjetaDeAjustes icono={Package} titulo={t('packs.heading')} testid="pack-history-section">
        {paquetes()}
      </TarjetaDeAjustes>

      {/* La ventana "Cancel subscription?" (AJ5) con el estilo de ventana del alumno: 560, la X de hoy, el
          triangulo en cuadro rojo suave, las cuatro vinetas DIBUJADAS y el velo sobre toda la pantalla (la
          pieza va en un portal a `body`, por encima de la barra de arriba). Su segunda boca, AJ6 (la misma
          ventana desde "Switch to Free"), dejo de existir con la firma 1. */}
      {showCancelModal && (
        <Ventana
          ancho={560}
          testid="cancel-modal"
          etiquetaId="cancel-modal-title"
          etiquetaCerrar={t('common:cancel')}
          alCerrar={() => setShowCancelModal(false)}
          titulo={(
            <span className="flex flex-col items-start gap-4">
              <IconoDeVentana tono="rojo" icono={AlertTriangle} />
              <span>{t('modals.cancel_title')}</span>
            </span>
          )}
          botones={(
            <>
              {/* #433 - aquí ya no se cancela: se abre la ventana del motivo, y su "Cancelar mi plan"
                  es el que llama al servidor. Ninguna llamada sale antes del motivo. */}
              <button type="button" onClick={() => { setShowCancelModal(false); setMotivoPara({ tipo: 'cancel' }); }}
                disabled={actionLoading} className={`${BOTON_VENTANA_SECUNDARIO} ${APRETADO}`} data-testid="cancel-confirm">
                {t('modals.confirm_cancellation_btn')}
              </button>
              <button type="button" onClick={() => setShowCancelModal(false)}
                className={`${BOTON_VENTANA_PRINCIPAL} ${APRETADO}`} data-testid="cancel-keep">
                {t('subscription.keep_plan', { plan: PLAN_LABELS[plan] })}
              </button>
            </>
          )}
        >
          <div className="flex flex-col gap-4 pb-1">
            <p className="text-[14px] leading-5 text-[#C8C8C8]">{intro}</p>
            <ListaConVinetas renglones={[
              <Trans key="f" t={t} i18nKey="settings:modals.switch_free" values={{ credits: PLAN_CREDITS.free }} components={{ 1: NEGRITA }} />,
              t('modals.lose_paid_benefits'),
              <Trans key="p" t={t} i18nKey="settings:modals.packs_unaffected" components={{ 1: NEGRITA }} />,
              t('modals.upgrade_again'),
            ]} />
            <p className="text-[14px] leading-5 text-[#9A9A9A]">{t('modals.confirm_cancel_q')}</p>
          </div>
        </Ventana>
      )}
    </div>
  );
}
